import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const processAppEventProperty = z
  .object({
    name: z.string().nullable().optional().describe('Field name'),

    type: z
      .string()
      .nullable()
      .optional()
      .describe('References a ProcessDataType name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether the field is always present'),

    description: z.string().nullable().optional().describe('Description'),
  })
  .describe('A field of an app event a process binds as a message.')
  .as('ProcessAppEventProperty', { embedded: true });

export { processAppEventProperty as processAppEventPropertySchema };
